/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { ThumbUp as ThumbUpIcon } from '@material-ui/icons';
import clsx from 'clsx';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import { TableCellHeaderProps } from 'components/TableItems/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import i18n from 'i18n';
import { getAllCompaniesRequest } from 'modules/companies/actions';
import {
  CompanyFields,
  ListCompanyDataProps,
} from 'modules/companies/interfaces';
import { modalClose } from 'modules/modal/actions';
import { setSelectedCompany } from 'modules/partners/actions';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { cyrb53Hash } from 'utils/helpers';
import { SearchBar } from 'components/SearchBar';
import { CompanyFieldsProps } from '.';
import styles from './styles';

const initialQuery = {
  offset: 0,
  limit: 10,
  search: '',
};

interface Props {
  isCompanyLoading: boolean;
  companyFields: CompanyFieldsProps | null;
  companyDetails: CompanyFields | null;
  setFieldValue: any;
  companyList: ListCompanyDataProps;
  setCompanyFields: (prop: CompanyFieldsProps | null) => void;
  getAllCompaniesRequest: (props) => void;
  setSelectedCompany: (prop: CompanyFields | null) => void;
  modalClose: () => void;
}

const CompanyList = ({
  isCompanyLoading,
  companyFields,
  companyList,
  setFieldValue,
  companyDetails,
  getAllCompaniesRequest,
  setCompanyFields,
  setSelectedCompany,
  modalClose,
}: Props) => {
  const headers: TableCellHeaderProps[] = [
    {
      key: 'display_name',
      i18n: 'COMPANY_NAME_KEY',
      order: true,
      style: { width: '40%' },
    },
    {
      key: 'trading_name',
      i18n: 'SINGLE_CORPORATE_NAME_KEY',
      order: true,
      style: { width: '40%' },
    },
    {
      key: 'zoho_id',
      i18n: 'ZOHO_ID_KEY',
      style: { width: '20%' },
    },
  ];

  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    itemOrder,
    query,
    handleLimitChange,
    handleOrder,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const getCompanies = () => {
    getAllCompaniesRequest({
      ...query,
    });
  };

  React.useEffect(() => {
    setSelectedCompany(companyDetails);
  }, [companyDetails]);

  React.useEffect(() => {
    getCompanies();
  }, [query]);

  return (
    <Grid>
      <SearchBar
        id="search-companies"
        isLoading={isCompanyLoading}
        handleSearch={handleSearch}
        setSearchValue={setSearchValue}
      />
      <TableItems
        header={
          <>
            <Grid item className={classes.select}>
              {' '}
            </Grid>
            {headers.map(item => (
              <TableCell
                key={item?.i18n}
                order={item?.order}
                style={item?.style}
                markOderItem={itemOrder === item?.key}
                handleOrder={() =>
                  item?.order ? handleOrder(item?.key) : null
                }
              >
                {i18n.t(item?.i18n)}
              </TableCell>
            ))}
          </>
        }
        renderItems={(item: CompanyFields, index) => (
          <TableRow
            key={cyrb53Hash(index)}
            onClick={() => {
              setCompanyFields({
                company_name: item?.company_name,
                company_uuid: item?.company_uuid,
              });
              setFieldValue('company_uuid', item?.company_uuid);
              modalClose();
            }}
            className={clsx(classes.tableRow, {
              [classes.itemSelected]:
                companyFields?.company_uuid === item?.company_uuid,
            })}
          >
            <TableCell className={classes.likeCell}>
              {item?.company_uuid === companyFields?.company_uuid ? (
                <ThumbUpIcon fontSize="small" />
              ) : (
                <></>
              )}
            </TableCell>
            <TableCell ellipsis>{item?.company_name}</TableCell>
            <TableCell ellipsis>{item?.trading_name}</TableCell>
            <TableCell>{item?.zoho_id}</TableCell>
          </TableRow>
        )}
        data={companyList}
        isLoading={isCompanyLoading}
        onChangePage={handlePageChange}
        onChangeLimit={handleLimitChange}
        overrideRowsCount={query.limit}
        notFoundText={
          <Typography>{i18n.t('MONITOR.NO_RESULTS_INSTANCES')}</Typography>
        }
      />
    </Grid>
  );
};

const mapStateToProps = ({
  companies: { companyList, isLoading: isCompanyLoading },
  partners: { selectedCompany },
}: ApplicationState) => ({
  companyList,
  isCompanyLoading,
  selectedCompany,
});

export default connect(mapStateToProps, {
  getAllCompaniesRequest,
  setSelectedCompany,
  modalClose,
})(CompanyList);
